
<div class="site-panel" v-if="site">
    <v-row class="no-frame">
        <v-col class="main-first-col modal-tab no-border">
            <c-site-contract-lim
                :unit-id  = "site.id"
                :unit     = "site"
                :contract = "limContract"
            />
        </v-col>
        <v-col class="main-middlle-col modal-tab no-border">
            <v-row class="no-frame">
                <c-site-contract-mnt
                    :unit-id  = "site.id"
                    :unit     = "site"
                    :contract = "mntContract"
                />
            </v-row>
        </v-col>
        <v-col class="main-middlle-col modal-tab no-border">
            <v-row class="no-frame">
                <c-site-contract-esc
                    :unit-id  = "site.id"
                    :unit     = "site"
                    :contract = "escContract"
                />
            </v-row>
        </v-col>
        <v-col class="main-last-col modal-tab no-border">
            <v-row class="no-frame">
                <c-site-contract-zus
                    :unit-id  = "site.id"
                    :unit     = "site"
                    :contract = "zusContract"
                />
            </v-row>
        </v-col>
    </v-row>
</div>
